/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserMetadataEntryDTO } from './UserMetadataEntryDTO';
import {
    UserMetadataEntryDTOFromJSON,
    UserMetadataEntryDTOFromJSONTyped,
    UserMetadataEntryDTOToJSON,
} from './UserMetadataEntryDTO';

/**
 * 
 * @export
 * @interface UserMetadataDTO
 */
export interface UserMetadataDTO {
    /**
     * 
     * @type {Array<UserMetadataEntryDTO>}
     * @memberof UserMetadataDTO
     */
    entries: Array<UserMetadataEntryDTO>;
}

/**
 * Check if a given object implements the UserMetadataDTO interface.
 */
export function instanceOfUserMetadataDTO(value: object): value is UserMetadataDTO {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function UserMetadataDTOFromJSON(json: any): UserMetadataDTO {
    return UserMetadataDTOFromJSONTyped(json, false);
}

export function UserMetadataDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMetadataDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(UserMetadataEntryDTOFromJSON)),
    };
}

export function UserMetadataDTOToJSON(value?: UserMetadataDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entries': ((value['entries'] as Array<any>).map(UserMetadataEntryDTOToJSON)),
    };
}

